import { useEffect, useState, useContext } from "react"
import { Formik, useFormik } from "formik"
import { userContext } from '../../contexts/userContext';
import { Contact, ChevronLeft } from "lucide-react";
import serverURL from "../../config/serverConfig";
// import { getProjectList } from "../scripts/getProjects"

const NewProjectForm = (props) => {

    const validate = values => {
        const errors = {}
        if (!values.title) {
            errors.title = 'Required'
        }
        if (!values.client) {
            errors.client = 'Required'
        }

        return errors;
    }

    const user_id = useContext(userContext);

    const [newClient, setNewClient] = useState(false) 
    const [clientCreated, setClientCreated] = useState(false)    
    const [clientName, setClientName] = useState('')
    const [clientEmail, setClientEmail] = useState('')
    const [clientPhone, setClientPhone] = useState('')
    const [clientID, setClientID] = useState('')

    const existingClients = props.clients || []
    const existingClientsList = existingClients.map((client) => {
        return (
            <option 
                key={client.client_id} 
                value={[client.name+"^"+ client.client_id]} //should this be just "client" to print the name or "client_id"?
                onClick={()=>{
                    // formik.setFieldValue('client', client.name); //can probably delete this, but will also need to update database
                    // formik.setFieldValue('client_id', client.client_id);
                    // setClientName(client.name);
                    // setClientID(client.client_id);
                }}
            >
                {client.name}
            </option>
        )
    })



    //load project list
    let today = new Date();
    const offset = today.getTimezoneOffset()
    today = new Date(today.getTime() - (offset*60*1000))
    let due = new Date(today)
    due.setDate(today.getDate()+7)

    const formik = useFormik({
        initialValues: {
            title: '',
            client: '',
            client_id: '',
            type: '',
            songs: 1,
            description: '',
            startDate: today.toISOString().split('T')[0],
            dueDate: due.toISOString().split('T')[0],
            status: 'Not Started',
            fee: 0,
            paid: 0


        },
        validate,
        onSubmit: values => {
            props.submit(values)
            formik.resetForm()
            let clientInfo = values.client.split("^");
            alert(`${clientInfo[0]} - ${values.title} has been created`)
        },
    });
    return (
        <form id="newProjectForm" className="flex" onSubmit={formik.handleSubmit}>
            <label htmlFor="title">Project Title</label>
            <input
                id="title"
                name="title"
                type="text"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.title}
            />
            {formik.touched.title && formik.errors.title ? <div className="formError">{formik.errors.title}</div> : null}
            {/* <label class="switch">
                <input type="checkbox" checked={newClient} onClick={()=>{setNewClient(!newClient)}} />
                <span class="slider round"></span>
            </label> */}
            <div id="clientSelect">
                <label htmlFor="artist">Select Artist</label>
                <button type="button" onClick={()=>{setNewClient(!newClient)}}>{newClient ? "Use Existing Client" : <div className="flex items-center gap-1"><Contact size={14} strokeWidth={1} /><span>Add New Artist/Client</span></div>}</button>
            </div>

            { newClient ?
                clientCreated ?
                    <div>
                        {clientName}
                        {/* {formik.values.client_id}
                        {formik.values.client} */}
                    </div>
                    :
                    <div id="newClientForm" className="glassBackBlack">
                        <div id="newClientFormBack" onClick={() => { setNewClient(false); formik.setFieldValue('client', ''); formik.setFieldValue('client_id', ''); }}><ChevronLeft size={16} strokeWidth={1} />Back</div>
                        <label htmlFor="client">Artist Name</label>
                            <input
                                id="client"
                                name="client"
                                type="text"
                                //onChange={formik.handleChange} //should update state instead of formik
                                onChange={e => {
                                    setClientName(e.target.value);
                                    formik.handleChange(e);
                                }}
                                onBlur={formik.handleBlur}
                                value={formik.values.client}
                            />
                            {formik.touched.client && formik.errors.client ? <div className="formError">{formik.errors.client}</div> : null}
                        <label htmlFor="client_email">Artist E-Mail</label>
                            <input
                                id="client_email"
                                name="client_email"
                                type="email"
                                //onChange={formik.handleChange} //should update state instead of formik
                                onChange={e => {
                                    setClientEmail(e.target.value);
                                }}
                                value={clientEmail}
                            />
                        <label htmlFor="phone">Artist Phone</label>
                            <input
                                id="phone"
                                name="phone"
                                type="tel"
                                pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                                //onChange={formik.handleChange} //should update state instead of formik
                                onChange={e => {
                                    setClientPhone(e.target.value);
                                }}
                                value={clientPhone}
                            />

                        <button type="button" onClick={() => {
                            console.log(clientEmail,clientPhone)
                            fetch(`${serverURL}createClient`, {
                                method: "POST",
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                                body: JSON.stringify({
                                    user_id: user_id[0],
                                    name: clientName,
                                    email: clientEmail,
                                    phone: clientPhone
                                }),
                            })
                            .then((response) => response.json())
                            .then((data) => {
                                console.log(data[0]);
                                alert(`${clientName} has been added as a new client`)
                                setClientCreated(true)
                                //save client id in form
                                formik.setFieldValue('client_id', data[0].client_id)
                                formik.setFieldValue('client', clientName)
                            })
                            .catch((error) => {
                                console.error('Error:', error);
                            });
                        }
                        }>+Save New Client</button>
                    </div>
                :
                <>

                    <select name="client" id="client" onChange={(e)=>{formik.handleChange(e); console.log("e: ",e.target.value)}} onBlur={formik.handleBlur} placeholder value={formik.values.client}>
                        <option value="" selected disabled hidden>Choose here</option>
                        {existingClientsList}
                    </select>
                </>
            }


            {/* <label htmlFor="artistEmail">Artist Email</label>
            <input
                id="artistEmail"
                name="artistEmail"
                type="email"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.artistEmail}
            /> */}

            {/* <label htmlFor="type">Type</label>
            <input
                id="type"
                name="type"
                type="text"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.type}
            /> */}

            {/* <label htmlFor="songs"># of Songs</label>
            <input
                id="songs"
                name="songs"
                type="number"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.songs}
            /> */}

            <label htmlFor="description">Description</label>
            <input
                id="description"
                name="description"
                type="text"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.description}
            />

            <label htmlFor="startDate">Start Date</label>
            <input
                id="startDate"
                name="startDate"
                type="date"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.startDate}
            />

            <label htmlFor="dueDate">Due Date</label>
            <input
                id="dueDate"
                name="dueDate"
                type="date"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.dueDate}
            />

            <label htmlFor="fee">Fee</label>
            <input
                id="fee"
                name="fee"
                type="number"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.fee}
            />

            <label htmlFor="paid">Paid</label>
            <input
                id="paid"
                name="paid"
                type="number"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.paid}
            />

            <button type="submit">CREATE</button>
        </form>
    )
}

export default NewProjectForm